import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function ExpertSection() {
  return <Section bg="cream-dark" data-id="element-204">
      <div className="max-w-6xl mx-auto" data-id="element-205">
        <div className="grid lg:grid-cols-[1fr_1.2fr] gap-12 lg:gap-20 items-center" data-id="element-206">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative" data-id="element-207">
            <div className="absolute -inset-4 bg-gold/10 rounded-[2.5rem] blur-xl -z-10" data-id="element-208" />
            <div className="aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl relative" data-id="element-209">
              <div className="absolute inset-0 bg-olive/10 mix-blend-multiply z-10" data-id="element-210" />
              <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=1000&auto=format&fit=crop" alt="Dra. Florencia Bertotto" className="w-full h-full object-cover grayscale-[20%]" data-id="element-211" />
            </div>

            {/* Floating Credentials */}
            <div className="absolute -bottom-6 -right-6 lg:-right-12 glass-card p-6 rounded-2xl max-w-[240px] z-20" data-id="element-212">
              <p className="font-serif italic text-3xl text-olive mb-1" data-id="element-213">12+</p>
              <p className="text-xs uppercase tracking-widest text-charcoal-light font-medium" data-id="element-214">
                Años acompañando mujeres argentinas
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-8" data-id="element-215">
            <div data-id="element-216">
              <p className="text-xs font-medium tracking-[0.2em] text-gold uppercase mb-4" data-id="element-217">
                La Creadora
              </p>
              <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-4" data-id="element-218">
                Dra. Florencia Bertotto
              </h2>
              <p className="text-lg text-olive font-light tracking-wide" data-id="element-219">
                Coach en Wellaging y Bienestar Integral
              </p>
            </div>

            <div className="space-y-6 text-charcoal-light font-light text-lg leading-relaxed" data-id="element-220">
              <p data-id="element-221">
                <span className="text-3xl font-serif italic text-gold leading-none mr-2" data-id="element-222">
                  "
                </span>
                Durante años vi en mi consultorio a mujeres brillantes y
                exitosas que llegaban a los 45 años sintiéndose agotadas,
                frustradas con su cuerpo y resignadas a que 'así es envejecer'.
              </p>
              <p data-id="element-223">
                La medicina tradicional les decía que sus análisis estaban
                'normales'. La industria cosmética les vendía cremas carísimas.
                Pero nadie les enseñaba cómo{' '}
                <strong className="font-medium text-charcoal" data-id="element-224">
                  optimizar su cuerpo
                </strong>{' '}
                para esta nueva etapa hormonal.
              </p>
              <p data-id="element-225">
                Por eso creé el Método Wellaging 360°. Para traducir la ciencia
                más avanzada de longevidad en pasos simples, aplicables a la
                vida real de una mujer argentina.
              </p>
            </div>

            <div className="grid grid-cols-2 gap-6 pt-8 border-t border-gold/20" data-id="element-226">
              <div data-id="element-227">
                <p className="text-xs uppercase tracking-widest text-charcoal/40 mb-2" data-id="element-228">
                  Formación
                </p>
                <p className="text-sm text-charcoal font-medium" data-id="element-229">
                  Nutrición Funcional
                </p>
              </div>
              <div data-id="element-230">
                <p className="text-xs uppercase tracking-widest text-charcoal/40 mb-2" data-id="element-231">
                  Especialidad
                </p>
                <p className="text-sm text-charcoal font-medium" data-id="element-232">
                  Coaching de Hábitos
                </p>
              </div>
            </div>

            <div className="pt-8 flex items-center gap-6" data-id="element-233">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Stylized_signature_of_Florencia.svg/1200px-Stylized_signature_of_Florencia.svg.png" alt="Firma Florencia" className="h-12 opacity-40 grayscale" onError={e => e.currentTarget.style.display = 'none'} data-id="element-234" />
              <p className="font-serif italic text-charcoal-light text-sm" data-id="element-235">
                "Tu vitalidad no tiene fecha de vencimiento."
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </Section>;
}